/* import __COLOCATED_TEMPLATE__ from './account-details-card.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { formatNumber } from '@banking/ui/utils/checking/utils';
import BankingToastComponent from '@banking/ui/components/banking/toast';
const ACCOUNT_NUMBER_INDICES = [9, 6, 3];
const ROUTING_NUMBER_INDICES = [6, 3];
let AccountDetailsCard = (_dec = computed('accountNumber', 'accountNumberSuffix', 'isAuthed', 'isToggleEnabled'), _dec2 = computed('routingNumber'), _class = class AccountDetailsCard extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "features", _descriptor2, this);
    _initializerDefineProperty(this, "flash", _descriptor3, this);
    _initializerDefineProperty(this, "savingsApy", _descriptor4, this);
    _initializerDefineProperty(this, "sentry", _descriptor5, this);
  }
  get accountNumberToDisplay() {
    return this.isToggleEnabled && this.isAuthed && this.accountNumber ? formatNumber(this.accountNumber, ACCOUNT_NUMBER_INDICES) : this.intl.t('banking.components.accountDetailsCard.accountNumber.masked', {
      accountNumberSuffix: this.accountNumberSuffix,
      htmlSafe: true
    });
  }
  get routingNumberToDisplay() {
    return formatNumber(this.routingNumber, ROUTING_NUMBER_INDICES);
  }
  showCopyFailedToast() {
    this.flash.globalWarning(this.intl.t('banking.components.accountDetailsCard.copyFailed'), {
      flashComponent: BankingToastComponent,
      dismiss: this.dismiss,
      componentOptions: {
        dismissLabel: this.intl.t('banking.shared.toast.dismiss')
      }
    });
  }
  showCopySuccessToast(key) {
    this.flash.globalSuccess(this.intl.t(key), {
      flashComponent: BankingToastComponent,
      dismiss: this.dismiss,
      componentOptions: {
        dismissLabel: this.intl.t('banking.shared.toast.dismiss')
      }
    });
  }
  async copyAccountNumber() {
    const clipboard = window.navigator?.clipboard;
    if (!clipboard?.writeText || !this.accountNumber) {
      this.showCopyFailedToast();
      return;
    }
    try {
      await clipboard.writeText(this.accountNumber);
      this.showCopySuccessToast('banking.components.accountDetailsCard.accountNumber.copied');
    } catch {
      this.showCopyFailedToast();
    }
  }
  async copyRoutingNumber() {
    const clipboard = window.navigator?.clipboard;
    if (!clipboard?.writeText || !this.routingNumber) {
      this.showCopyFailedToast();
      return;
    }
    try {
      await clipboard.writeText(this.routingNumber);
      this.showCopySuccessToast('banking.components.accountDetailsCard.routingNumber.copied');
    } catch {
      this.showCopyFailedToast();
    }
  }
  dismiss() {
    return this.flash.clearGlobalMessage();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "flash", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "savingsApy", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "accountNumberToDisplay", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "accountNumberToDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "routingNumberToDisplay", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "routingNumberToDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "copyAccountNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "copyAccountNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "copyRoutingNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "copyRoutingNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismiss", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dismiss"), _class.prototype), _class);
export { AccountDetailsCard as default };